import React, { useEffect } from "react";
import { NavLink, Route } from "react-router-dom";
import Navigation from "../../components/Navigations/MainNavigation";
import Profile from "../../components/UserProfile/Profile";
import Favourites from "../../components/UserProfile/Favourites";
import Orders from "../../components/UserProfile/Orders/Orders";

import Footer from "../../components/Footer";

import styled from "styled-components";

const Container = styled.div`
  width: 100%;
`;
const ProfileContainer = styled.div`
  width: 80%;
  margin-left: 10%;
  padding: 100px 0;
  height: 100vh;
  @media (max-width: 769px) {
    padding: 80px 0;
    width: 90%;
    margin-left: 5%;
  }
`;
const ProfileNav = styled.div`
  width: 22%;
  height: 100%;
  float: left;
  @media (max-width: 769px) {
    display: none;
  }
`;
const ProfileMain = styled.div`
  width: 73%;
  height: 100%;

  float: right;
  @media (max-width: 769px) {
    width: 100%;
  }
`;
const NavItem = styled(NavLink)`
  background: white;
  display: block;
  margin-bottom: 10px;
  text-align: center;
  padding: 10px 0;
  border-radius: 5px;
  text-decoration: none;
  border: 1px solid #eee;
  font-weight: 500;
  color: black;
`;
function UserProfile() {
  useEffect(() => {
    window.scrollTo(0, 0);
  });
  return (
    <Container>
      <Navigation />
      <ProfileContainer>
        <ProfileNav>
          <NavItem
            exact
            to="/user-profile"
            activeStyle={{ background: "#F5F5F5" }}
          >
            Profile
          </NavItem>
          <NavItem
            to="/user-profile/orders"
            activeStyle={{ background: "#F5F5F5" }}
          >
            Orders
          </NavItem>
          <NavItem
            to="/user-profile/favourites"
            activeStyle={{ background: "#F5F5F5" }}
          >
            Favourites
          </NavItem>
        </ProfileNav>
        <ProfileMain>
          <Route path="/user-profile" exact component={Profile} />
          <Route path="/user-profile/favourites" exact component={Favourites} />
          <Route path="/user-profile/orders" component={Orders} />
        </ProfileMain>
      </ProfileContainer>
      <Footer />
    </Container>
  );
}

export default UserProfile;
